import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/stock/stock-e4.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/FooterTalkLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds/e/HeaderAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/SegmentTabs.tsx");
